module.exports = __webpack_public_path__ + "img/q12.a8ae5653.png";